module.exports = __webpack_public_path__ + "img/description_outlined.1135a9b1.svg";